module.exports = __webpack_public_path__ + "static/media/animal9.1569e360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animals/animal9.png
// module id = 770
// module chunks = 0